"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationApp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Animation_1 = require("./Animation");
const AnimationContext_1 = require("./AnimationContext");
function getAnimationEffectOfElement(props) {
    var _a, _b;
    if (props.selectedElements.length > 1) {
        /**
         * If the selected element has an animation effect, return it.
         * Otherwise, return undefined.
         */
        const effects = props.selectedElements.map((element) => { var _a; return (_a = props.elementAnimations) === null || _a === void 0 ? void 0 : _a[element]; });
        /**
         * Newly created groups have no animation effect or have different animation effects.
         * If the selected elements have different animation effects, return undefined.
         * Otherwise, return the animation effect.
         */
        const hasDifferentEffects = effects.some((effect) => effect !== effects[0]);
        return hasDifferentEffects ? undefined : effects[0];
    }
    return (_a = props.elementAnimations) === null || _a === void 0 ? void 0 : _a[(_b = props.selectedElements) === null || _b === void 0 ? void 0 : _b[0]];
}
function AnimationApp(props) {
    var _a, _b, _c;
    const [animation, setAnimation] = (0, react_1.useState)(props.animation);
    const [elementAnimation, setElementAnimation] = (0, react_1.useState)(getAnimationEffectOfElement(props));
    const [activeTabIndex, setActiveTabIndex] = (0, react_1.useState)(props.selectedElements.length > 0 ? 1 : 0);
    const [pageDuration, setPageDuration] = (0, react_1.useState)((_a = props.pageDuration) !== null && _a !== void 0 ? _a : props.minimumPageDuration);
    const [minimumPageDuration, setMinimumPageDuration] = (0, react_1.useState)((_b = props.minimumPageDuration) !== null && _b !== void 0 ? _b : 0);
    const onAnimationChange = (animation) => {
        var _a;
        activeTabIndex === 0 // If the tab is page animation
            ? setAnimation(animation)
            : setElementAnimation(animation);
        (_a = props.onAnimationChange) === null || _a === void 0 ? void 0 : _a.call(props, animation);
    };
    const onActiveTabChange = (index) => {
        var _a;
        setActiveTabIndex(index);
        (_a = props.onActiveTabChange) === null || _a === void 0 ? void 0 : _a.call(props, index);
    };
    const onConfigurationChange = (key, value) => {
        var _a;
        if (key === 'pageDuration' && typeof value === 'number') {
            setPageDuration(value);
        }
        (_a = props.onConfigurationChange) === null || _a === void 0 ? void 0 : _a.call(props, key, value);
    };
    (0, react_1.useEffect)(() => {
        setAnimation(props.animation);
    }, [props.animation]);
    (0, react_1.useEffect)(() => {
        if (props.selectedElements.length > 0 && activeTabIndex === 0) {
            setActiveTabIndex(1);
        }
        setElementAnimation(getAnimationEffectOfElement(props));
    }, [props.selectedElements]);
    (0, react_1.useEffect)(() => {
        setElementAnimation(getAnimationEffectOfElement(props));
    }, [props.elementAnimations]);
    (0, react_1.useEffect)(() => {
        var _a;
        setMinimumPageDuration((_a = props.minimumPageDuration) !== null && _a !== void 0 ? _a : 0);
    }, [props.minimumPageDuration]);
    (0, react_1.useEffect)(() => {
        if (props.pageDuration !== pageDuration) {
            setPageDuration(props.pageDuration);
        }
        setElementAnimation(getAnimationEffectOfElement(props));
    }, [props.pageDuration]);
    return ((0, jsx_runtime_1.jsx)(AnimationContext_1.AnimationContext.Provider, { value: Object.assign(Object.assign({}, props), { variant: (_c = props.variant) !== null && _c !== void 0 ? _c : 'default', pageDuration,
            minimumPageDuration,
            activeTabIndex,
            animation,
            elementAnimation,
            onActiveTabChange,
            onAnimationChange,
            onConfigurationChange }), children: (0, jsx_runtime_1.jsx)(Animation_1.Animation, {}) }));
}
exports.AnimationApp = AnimationApp;
//# sourceMappingURL=App.js.map